import {FadeInOutView, styled} from '@innowise-group/ui-kit';

export const FadeInOutViewWrap = styled(FadeInOutView)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  transition: all 0.8s;
`;

export const Content = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 5px;

  @media (max-width: 769px) {
    flex-wrap: wrap;
  }

  @media (max-width: 481px) {
    padding-left: 14px;
  }
`;
